import { Action } from 'redux';
import { DomainDetail, DomainPayload } from '@dev/ee-api/ee-api-models';
export interface AddDomainErrorMessage {
    message: string;
    messageId?: string;
    messageParts?: string[];
}

export enum ActionTypes {
    DOMAIN_FETCH_START = '@@domain/DOMAIN_FETCH_START',
    DOMAIN_FETCH_SUCCESS = '@@domain/DOMAIN_FETCH_SUCCESS',
    DOMAIN_FETCH_ERROR = '@@domain/DOMAIN_FETCH_ERROR',
    DOMAIN_ADD_START = '@@domain/DOMAIN_ADD_START',
    DOMAIN_ADD_FINISH = '@@domain/DOMAIN_ADD_FINISH',
    DOMAIN_ADD_ERROR = '@@domain/DOMAIN_ADD_ERROR',
    DOMAIN_FETCH_SINGLE = '@@domain/DOMAIN_FETCH_SINGLE',
    DOMAIN_FETCH_SINGLE_SUCCESS = '@@domain/DOMAIN_FETCH_SINGLE_SUCCESS',
    DOMAIN_VERIFY_START = '@@domain/DOMAIN_VERIFY_START',
    DOMAIN_VERIFY_SUCCESS = '@@domain/DOMAIN_VERIFY_SUCCESS',
    DOMAIN_VERIFY_ERROR = '@@domain/DOMAIN_VERIFY_ERROR',
    DOMAIN_DELETE_START = '@@domain/DOMAIN_DELETE_START',
    DOMAIN_DELETE_SUCCESS = '@@domain/DOMAIN_DELETE_SUCCESS',
    DOMAIN_SET_DEFAULT = '@@domain/DOMAIN_SET_DEFAULT',
    DOMAIN_SET_DEFAULT_SUCCESS = '@@domain/DOMAIN_SET_DEFAULT_SUCCESS',
    DOMAIN_SET_DEFAULT_ERROR = '@@domain/DOMAIN_SET_DEFAULT_ERROR',
    DOMAIN_UPDATE_START = '@@domain/DOMAIN_UPDATE_START',
    DOMAIN_UPDATE_SUCCESS = '@@domain/DOMAIN_UPDATE_SUCCESS',
    DOMAIN_UPDATE_ERROR = '@@domain/DOMAIN_UPDATE_ERROR',
    DOMAIN_CLEAR_SINGLE_DOMAIN = '@@domain/DOMAIN_CLEAR_SINGLE_DOMAIN',
}

export interface DomainFetchStartAction extends Action {
    type: ActionTypes.DOMAIN_FETCH_START;
}
export interface DomainFetchSuccessAction extends Action {
    type: ActionTypes.DOMAIN_FETCH_SUCCESS;
    payload: {
        domains: DomainDetail[];
    };
}
export interface DomainFetchErrorAction extends Action {
    type: ActionTypes.DOMAIN_FETCH_ERROR;
}
export interface DomainAddStartAction extends Action {
    type: ActionTypes.DOMAIN_ADD_START;
    payload: {
        newDomain: DomainPayload;
    };
    meta: {
        thunk: boolean;
    };
}
export interface DomainAddFinishAction extends Action {
    type: ActionTypes.DOMAIN_ADD_FINISH;
    payload: {
        domain: DomainDetail;
    };
    meta?: Record<string, unknown>;
}
export interface DomainAddErrorAction extends Action {
    type: ActionTypes.DOMAIN_ADD_ERROR;
    payload: AddDomainErrorMessage;
    meta?: Record<string, unknown>;
    error: boolean;
}
export interface DomainFetchSpecificStartAction extends Action {
    type: ActionTypes.DOMAIN_FETCH_SINGLE;
    payload: {
        domainName: string;
    };
}
export interface DomainFetchSpecificSuccessAction extends Action {
    type: ActionTypes.DOMAIN_FETCH_SINGLE_SUCCESS;
    payload: {
        specificDomain: DomainDetail;
    };
}
export interface DomainVerifySpecificStartAction extends Action {
    type: ActionTypes.DOMAIN_VERIFY_START;
    payload: {
        domainName: string;
    };
    meta: {
        thunk: boolean;
    };
}
export interface DomainVerifySpecificSuccessAction extends Action {
    type: ActionTypes.DOMAIN_VERIFY_SUCCESS;
    payload: {
        domain: DomainDetail;
    };
    meta?: Record<string, unknown>;
}
export interface DomainVerifySpecificErrorAction extends Action {
    type: ActionTypes.DOMAIN_VERIFY_ERROR;
    payload: {
        message: string;
    };
    meta: Record<string, unknown>;
    error: boolean;
}
export interface DomainDeleteSpecificStartAction extends Action {
    type: ActionTypes.DOMAIN_DELETE_START;
    payload: {
        domainName: string;
    };
}
export interface DomainDeleteSpecificSuccessAction extends Action {
    type: ActionTypes.DOMAIN_DELETE_SUCCESS;
}
export interface DomainSetDefaultAction extends Action {
    type: ActionTypes.DOMAIN_SET_DEFAULT;
    payload: {
        email: string;
    };
    meta: {
        thunk: boolean;
    };
}
export interface DomainSetDefaultSuccessAction extends Action {
    type: ActionTypes.DOMAIN_SET_DEFAULT_SUCCESS;
    meta: Record<string, unknown>;
}
export interface DomainSetDefaultErrorAction extends Action {
    type: ActionTypes.DOMAIN_SET_DEFAULT_ERROR;
    meta: Record<string, unknown>;
}
export interface DomainUpdateStartAction extends Action {
    type: ActionTypes.DOMAIN_UPDATE_START;
    payload: {
        domainName: string;
        updatedOption: DomainDetail;
    };
    meta: {
        thunk: boolean;
    };
}
export interface DomainUpdateSuccessAction extends Action {
    type: ActionTypes.DOMAIN_UPDATE_SUCCESS;
    payload: {
        domains: DomainDetail[];
    };
    meta;
}
export interface DomainUpdateErrorAction extends Action {
    type: ActionTypes.DOMAIN_UPDATE_ERROR;
    payload: {
        message: string;
    };
    meta: Record<string, unknown>;
    error: boolean;
}
export interface ClearSingleDomainAction extends Action {
    type: ActionTypes.DOMAIN_CLEAR_SINGLE_DOMAIN;
}
export interface DomainState {
    loadingDomains?: boolean;
    domains?: DomainDetail[];
    singleDomain?: DomainDetail;
}
